import Vue from 'vue';
import VueRouter from 'vue-router';
import dashboard from '../views/dashboard.vue';
import store from '@/store/store';
import AccountService from '@/services/AccountService.js';

async function requireAuth(to, from, next) {
	let isLoggedIn = AccountService.isUserSignedIn(); 

	// if not logged in, let's get the login form
	if (!isLoggedIn) {
		console.info('retreiving hosted login form');
		await AccountService.getSession();
	}

	// grab the tokens if either is missing
	if (isLoggedIn && (!store.getters.getAccessToken || !store.getters.getRefreshToken)) {
		await store.dispatch("getAccessToken");
		await store.dispatch("getRefreshToken");
	}

	// Get info about the user if we don't have it
	if (isLoggedIn && !store.getters.getLoggedInUserId) {
		await store.dispatch('getLoggedInUserInfo');
	}

	next(); // continue navigation
}

function allowTenantSwap(to, from, next) {
	if (store.account.tenantId === 'master') {
		to = '/';
	}

	next();
}

const routes = [
	{
		path: '/',
		redirect: 'Configuration', //temporary - will route to dashboard in the future
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: dashboard,
		redirect: 'Configuration', // temp
		beforeEnter: requireAuth
	},
	{
		path: '/reports',
		name: 'Reports',
		redirect: 'NotFound', // temp
		beforeEnter: requireAuth,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "reports" */ '../views/reports.vue')
	},

	{
		path: '/api',
		name: 'API',
		redirect: 'NotFound', // temp
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "api" */ '../views/api.vue')
	},
	{
		path: '/configuration',
		name: 'Configuration',
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "configuration" */ '../views/configuration.vue')
	},
	{
		path: '/configuration/history/:id?/:deployEndDateTime?',
		name: 'Configuration History',
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "configuration" */ '../views/configuration.vue')
	},
	{
		path: '/configuration/factors-&-decisions/:type?/:id?',
		name: 'Configuration Factors & Decisions',
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "configuration" */ '../views/configuration.vue')
	},
	{
		path: '/configuration/explorer/:step/:id?',
		name: 'Configuration Explorer',
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "configuration-explorer" */ '../views/configuration-explorer.vue'),
	},
	{
		path: '/account',
		name: 'Account',
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "Account" */ '../views/account.vue')
	},
	{
		path: '/selecttenant',
		name: 'Select Tenant',
		beforeEnter: requireAuth,
		beforeRouteEnter: allowTenantSwap,
		component: () => import(/* webpackChunkName: "select-tenant" */ '../views/select-tenant.vue')
	},
	{
		path: '/logout',
		name: 'Logout',
		redirect: '/login',
		beforeEnter() {
			store.dispatch('logout');
		}
	},
	{
		path: '/login',
		name: 'Login',
		beforeEnter() {
			AccountService.getSession();
		}
	},
	{
		path: '/login/oauth2/code/cognito',
		beforeEnter() {
			//if we end up here but are already loggedin - just let the redirect handle it...
			if (!AccountService.isUserSignedIn()) {
				var currUrl = window.location.href;
				AccountService.parseCognitoResponse(currUrl);
			}
		}
	},
	{
		path: '/support',
		name: 'Support',
		redirect: 'NotFound', // temp
		beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "support" */ '../views/support.vue')
	},
	{
		path: '*',
		name: 'NotFound',
		//beforeEnter: requireAuth,
		component: () => import(/* webpackChunkName: "NotFound" */ '../views/notfound.vue')
	}
];

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});


router.beforeEach((to, from, next) => {
	// store the intended location so we can put the user back where they meant to be
	let storageWindow = window.sessionStorage;
	let target = store.getters.getPostLoginUrl;

	/*
		If the to.path isn't cognito, then trust it.
		Otherwise, we'll check for a locally stored path.
		If neither works, we'll just trust whatever vue already has.
	*/
	if (!to.path.includes('/login')) {
		target = to.path;
	} else if (storageWindow.getItem('qvo.targetUrl')) {
		target = storageWindow.getItem('qvo.targetUrl');
	}

	// make extra sure we're not looping on the cognito screen
	if (target.includes('/login') || target.includes('/logout')) {
		target = "/";
	}

	// update the store & local storage to cover our bases
	store.dispatch('setPostLoginUrl', target);
	storageWindow.setItem('qvo.targetUrl', target);

	next();
});

export default router;